'use client';

import { useEffect, useState } from 'react';
import { useLocale } from '@/lib/i18n/LocaleContext';

const TIME_FORMAT = new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: 'Asia/Baghdad',
});

export function erbilTime(date: Date = new Date()): string {
  return TIME_FORMAT.format(date);
}

/**
 * Tiny live "the studio is on" line for the hero — Erbil local time with a
 * breathing accent dot. Renders a placeholder until mounted so the statically
 * exported HTML never carries a stale build-time clock.
 */
export function HeroStatusLine({ className = '' }: { className?: string }) {
  const { dict } = useLocale();
  const [time, setTime] = useState<string | null>(null);

  useEffect(() => {
    const update = () => setTime(erbilTime());
    update();
    const interval = setInterval(update, 30_000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`items-center gap-3 font-mono text-[11px] tracking-[0.28em] uppercase text-white/40 ${className}`}
      aria-hidden="true"
    >
      <span
        className="h-1.5 w-1.5 rounded-full animate-pulse"
        style={{ backgroundColor: 'var(--color-accent, #34d399)' }}
      />
      <span suppressHydrationWarning>
        {dict.hero.statusLine.location} <bdi dir="ltr">{time ?? '--:--'}</bdi> {dict.hero.statusLine.systemsLive}
      </span>
    </div>
  );
}
